import React from 'react'
import classNames from 'classnames'
import IconClose from 'components/partials/IconClose'

function ClearButton({ label, onClick, modifierClasses = [] }) {
  const clearButtonClasses = classNames(
    modifierClasses
  )

  return (
    <button
      onClick={onClick}
      className={clearButtonClasses}
    >
      <IconClose/>
      <span className="visually-hidden">{label}</span>
    </button>
  )
}

export default ClearButton
